// Paired before/after images for project showcase.
// "before" = empty/bare rooftop or building. "after" = with solar panels installed.

export const PROJECT_PAIRS = {
  // Commercial/factory
  factory1: {
    before: "https://images.unsplash.com/photo-1664375237744-ce6f80dabaa1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NTM2OTl8MHwxfHNlYXJjaHwyfHxlbXB0eSUyMHJvb2Z0b3B8ZW58MHx8fHwxNzI4OTM2MDAwfDA&ixlib=rb-4.0.3&q=80&w=1200",
    after: "https://images.unsplash.com/photo-1745321633881-d2d2218911bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxmYWN0b3J5JTIwY29tbWVyY2lhbCUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  },
  factory2: {
    before: "https://images.unsplash.com/photo-1581094289810-adf5d25690e3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    after: "https://images.unsplash.com/photo-1552197892-f2ad2f75e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxmYWN0b3J5JTIwY29tbWVyY2lhbCUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  },
  // Residential
  residential: {
    before: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    after: "https://images.unsplash.com/flagged/photo-1566838803980-56bfa5300e8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxmYW1pbHklMjBob3VzZSUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  },
  residential2: {
    before: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    after: "https://images.unsplash.com/photo-1640802396402-094375631000?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxmYW1pbHklMjBob3VzZSUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  },
  // Engineers / hospital
  engineers2: {
    before: "https://images.unsplash.com/photo-1486325212027-8081e485255e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    after: "https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVsJTIwZW5naW5lZXJzJTIwd29ya2luZ3xlbnwwfHx8fDE3Nzg1MjcwMDB8MA&ixlib=rb-4.1.0&q=85",
  },
  // EV
  ev1: {
    before: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    after: "https://images.unsplash.com/photo-1692052664566-477579a08e8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxldiUyMGNoYXJnaW5nJTIwc3RhdGlvbiUyMHNvbGFyfGVufDB8fHx8MTc3ODUyNzAwMHww&ixlib=rb-4.1.0&q=85",
  },
};
